import React, { useState } from 'react';

import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Paper from '@mui/material/Paper';
import Slide from '@mui/material/Slide';
import FormControlLabel from '@mui/material/FormControlLabel';

import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import SvgIcon from "@mui/material/SvgIcon";
import Icon from "@mui/material/Icon";
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';

import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';

import Slider from '@mui/material/Slider';

import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Divider from '@mui/material/Divider';

import CreateIcon from '@mui/icons-material/Create';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';

import { ReactComponent as MetronomeIcon } from "../29689/metronome.svg";

import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import DeleteIcon from '@mui/icons-material/Delete';

import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import StopIcon from '@mui/icons-material/Stop';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

import { ThemeProvider, createTheme } from '@mui/material/styles';

import PlaybackSettingsPage from "./PlaybackSettingsPage.js"
import PrintingPage from "./PrintingPage.js"
import SettingsPage from "./SettingsPage.js"
import ScoreManagementPage from "./ScoreManagementPage.js"
import Keyboard from "./Keyboard/Keyboard.js"

import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import DownloadIcon from '@mui/icons-material/Download';

import GradientSlider from "./GradientSlider.js"

import { styled } from '@mui/material/styles';

import testSong from "./test.ogg"

import TextManager from '../TextManager';

const RECORDING_BITRATE = 128000;
const DEFUALT_VOLUME = 1;

const NavigationBarResponsiveWidth = "800px";

const StyledButton = styled(Button)(({ theme }) => ({
	border: "0",
	// border: "1px solid black",
	boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)",

	minWidth: "0",

	// borderWidth: "2px",
	color: "black",

	":active": {
		border: "0",
		boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)",
		// border: "1px solid black",
	},

	":focus": {
		border: "0",
		boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)",
		// border: "1px solid black",
	},

	":hover": {
		border: "0",
		boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)",
		// border: "1px solid black",
	},
}));

export default class RecordingToolbar extends React.Component {

	state = {
		isRecording: false,
		isPlaybackPaused: true,

		hasPermission: false,

		mediaRecorder: null,

		recordingTime: 0,

		playbackTime: 0,
		playbackDuration: 0,

		displayedPlaybackVolume: DEFUALT_VOLUME,

		recordingUrl: null,

		isNarrowScreen: window.matchMedia(`(max-width: ${NavigationBarResponsiveWidth})`).matches,

		menuOpened: false,
		menuItems: null,
		menuAnchor: null,
	}

	recordedChunks = [];
	counterInterval = null;
	playbackSeekbarUpdateInterval = null;

	playbackAudioElementRef = React.createRef();

	componentDidMount() {
		const audio = this.playbackAudioElementRef.current;
		audio.volume = DEFUALT_VOLUME;

		window.addEventListener('resize', () => {

			this.setState({
				menuOpened: false,
				isNarrowScreen: window.matchMedia(`(max-width: ${NavigationBarResponsiveWidth})`).matches,
			});
		});

		// this.dummyRecord();
	}

	tryStartRecording = async () => {
		this.pausePlayback();

		if (navigator.mediaDevices) {
			try {
				const streamData = await navigator.mediaDevices.getUserMedia({
					audio: true,
					video: false,
				});

				this.setState({
					hasPermission: true,
					mediaRecorder: new MediaRecorder(streamData, {
						audioBitsPerSecond: RECORDING_BITRATE
					}),
					recordingTime: 0,
				}, () => {
					this.setState({ isRecording: true });
					this.state.mediaRecorder.start();

					this.counterInterval = setInterval(() => {
						this.setState({ recordingTime: this.state.recordingTime + 1 });
					}, 1000);

					this.state.mediaRecorder.ondataavailable = (event) => {
						if (this.counterInterval != null) {
							clearInterval(this.counterInterval);
						}

						this.onRecordingDataAvailable(event);


					};
				});

			} catch (error) {
				return false;
			}
		} else {
			return false;
		}

		return true;
	};

	encodeAndGetRecordingUrl() {
		if (this.recordedChunks == null) {
			return "";
		}

		const blob = new Blob(this.recordedChunks, {
			type: "audio/ogg",
		});
		const url = URL.createObjectURL(blob);

		// console.log(blob);

		// const a = document.createElement("a");
		// document.body.appendChild(a);
		// a.style = "display: none";
		// a.href = url;
		// a.download = "test.ogg";
		// a.click();

		// window.URL.revokeObjectURL(url);

		return url;
	}

	hasRecording() {
		return this.state.recordingUrl != null && this.state.recordingUrl != "";
	}

	downloadRecording() {
		if (!this.hasRecording()) {
			return;
		}

		const a = document.createElement("a");
		document.body.appendChild(a);
		a.style = "display: none";
		a.href = this.state.recordingUrl;
		a.download = "recording.ogg";
		a.click();
	}

	startRecording() {
		this.setState({ isRecording: true });
		this.state.mediaRecorder.start()

		if (this.hasRecording()) {
			window.URL.revokeObjectURL(this.state.recordingUrl);
		}

		this.recordedChunks = [];
	}

	stopRecording() {

		this.setState({
			isRecording: false,
			playbackDuration: this.state.recordingTime, // will be later replaced by the actual duration
			recordingTime: 0,
			playbackTime: 0,
		});

		if (this.counterInterval != null) {
			clearInterval(this.counterInterval)
		}

		this.state.mediaRecorder.stop()
	}

	onRecordingDataAvailable(event) {
		console.log("data-available", event);

		if (event.data.size > 0) {
			this.recordedChunks.push(event.data);

			const recordingUrl = this.encodeAndGetRecordingUrl();
			// console.log(recordingUrl)

			console.log(event.data.size * 8.0 / RECORDING_BITRATE);

			this.setState({
				recordingUrl: recordingUrl,
				playbackDuration: event.data.size * 8.0 / RECORDING_BITRATE,
			}, () => {
				this.playbackAudioElementRef.current.load();
			});

			this.recordedChunks = [];
		}
	}

	dummyRecord() {
		const audio = this.playbackAudioElementRef.current;

		audio.src = testSong;
		// audio.load();

		audio.addEventListener('loadedmetadata', () => {
			this.setState({
				playbackDuration: audio.duration
			});
		}, false);
	}

	startPlayback() {
		if (this.playbackAudioElementRef.current.src == "") {
			return;
		}

		this.setState({ isPlaybackPaused: false });

		this.playbackAudioElementRef.current.play();

		this.playbackSeekbarUpdateInterval = setInterval(() => {
			this.setState({ playbackTime: this.playbackAudioElementRef.current.currentTime });

			// console.log("playback: " + this.playbackAudioElementRef.current.currentTime.toFixed(2) + " : "  + this.state.playbackDuration.toFixed(2))

		}, 500)
	}

	seekPlayback(time) {
		this.playbackAudioElementRef.current.currentTime = time;
		this.setState({ playbackTime: time });
	}

	pausePlayback() {
		this.setState({ isPlaybackPaused: true });

		this.playbackAudioElementRef.current.pause();

		if (this.playbackSeekbarUpdateInterval != null) {
			clearInterval(this.playbackSeekbarUpdateInterval)
		}
	}

	render() {
		const divider = (
			<Box sx={{
				background: "#111111",
				width: "2px",
				minWidth: "2px",
				height: "70%",
				margin: "0px 20px 0px 20px"
			}} />
		);

		const getFormattedTimeText = (time) => {
			const min = Math.floor(time / 60.0);
			const sec = Math.round(time - min * 60.0);

			const minText = min.toString();
			const secText = sec.toString().padStart(2, "0");

			return minText + ":" + secText;
		}

		let playbackToolbar = (
			<Stack direction="row" sx={{
				// backgroundColor: "rgba(255,255,255,1.0)", 
				/*backdropFilter: "blur(5px)", */
				// boxShadow: "0 0 15px rgba(0,0,0,1.0)",
				// zIndex: 1,
				color: "#111111",
				alignItems: "center",
				// justifyContent: "center",

				height: "45px",

				width: "fit-content",


				// overflowX: "hidden",
				// overflowY: "hidden",

			}}>

				<IconButton size="small" onClick={async () => {
					// this.startRecording();
					const recordingStartSucessfully = await this.tryStartRecording();
					//console.log(recordingStartSucessfully);

				}}>
					<FiberManualRecordIcon sx={{
						fill: "red"
					}} />
				</IconButton>

				{divider}

				<IconButton size="small" onClick={() => {
					if (this.state.isPlaybackPaused) {
						this.startPlayback();
					} else {
						this.pausePlayback();
					}

				}}>
					{
						this.state.isPlaybackPaused ?
							(<PlayArrowIcon sx={{
								fill: "url(#gradientId)"
							}} />) :
							(<PauseIcon sx={{
								fill: "url(#gradientId)"
							}} />)
					}

				</IconButton>

				<Typography sx={{ margin: "0px 6px" }}> {getFormattedTimeText(this.state.playbackTime)} </Typography>

				<GradientSlider
					min={0} max={this.state.playbackDuration} step={1}
					value={this.state.playbackTime}
					onChange={(e, v) => {
						this.seekPlayback(v);
					}}
					sx={{
						width: "100px",
						minWidth: "100px",
						margin: "0 10px",
					}}
				/>

				<Typography sx={{ margin: "0px 6px" }}> {getFormattedTimeText(this.state.playbackDuration)} </Typography>

				{divider}

				<Typography sx={{ margin: "0px 6px" }}>{TextManager.getText("volume")}</Typography>

				<GradientSlider
					min={0} max={1} step={0.1}
					defaultValue={this.state.displayedPlaybackVolume}
					onChange={(e, v) => {
						const audio = this.playbackAudioElementRef.current;
						if (audio != null) {
							audio.volume = v;
							this.setState({ displayedPlaybackVolume: v });
						}
					}}
					sx={{
						width: "100px",
						minWidth: "100px",
						margin: "0 10px",
					}}
				/>

				{this.hasRecording() ? divider : null}

				{
					this.hasRecording() ?
						<Button
							onClick={() => {
								this.downloadRecording();
							}}
							sx={{
								whiteSpace: "nowrap"
							}}
						>
							{TextManager.getText("download")}
						</Button> : null
				}

			</Stack>
		)

		let recordingToolbar = (
			<Stack direction="row" sx={{
				// backgroundColor: "rgba(255,255,255,1.0)", 
				/*backdropFilter: "blur(5px)", */
				// boxShadow: "0 0 15px rgba(0,0,0,1.0)",
				// zIndex: 1,
				color: "#111111",
				alignItems: "center",
				// justifyContent: "center",

				height: "45px",

				width: "fit-content",


				// overflowX: "hidden",
				// overflowY: "hidden",

			}}>

				<IconButton size="small" onClick={() => {
					this.stopRecording();
				}}>
					<StopIcon sx={{
						fill: "red"
					}} />
				</IconButton>

				<Typography sx={{ margin: "0px 6px", color: "red" }}>{TextManager.getText("recording")} ({getFormattedTimeText(this.state.recordingTime)})</Typography>

			</Stack>
		)



		////////////////////////////////////////////////////////////////
		// Mobile
		////////////////////////////////////////////////////////////////
		const closeMenu = () => {
			this.setState({
				menuOpened: false
			});
		}

		const menuItems = <GradientSlider
			orientation="vertical"
			min={0} max={1} step={0.1}
			defaultValue={this.state.displayedPlaybackVolume}
			onChange={(e, v) => {
				const audio = this.playbackAudioElementRef.current;
				if (audio != null) {
					audio.volume = v;
					this.setState({ displayedPlaybackVolume: v });
				}
			}}
			sx={{
				height: "100px",
				maxHeight: "100px",
				margin: "10px 0",
				'& input[type="range"]': {
					WebkitAppearance: 'slider-vertical',
				},
			}}
		/>

		const playbackToolbarMobile = <Stack direction="row" sx={{
			// boxsizing: "border-box",
			color: "#111111",
			height: "45px",
			maxWidth: "300px",
			width: "100%",
			justifyContent: "space-between",
			alignItems: "center",
			// padding: "10px 0px",
		}}>
			<Button sx={{ width: "40px", height: "35px" }} onClick={async () => {
				// this.startRecording();
				const recordingStartSucessfully = await this.tryStartRecording();
				//console.log(recordingStartSucessfully);

			}}>
				<FiberManualRecordIcon sx={{
					fill: "red",
					height: "30px",
				}} />
			</Button>

			<Stack direction="row" sx={{
				justifyContent: "center",
				alignItems: "center",

			}}>
				<Button sx={{ width: "40px", height: "35px" }} onClick={() => {
					if (this.state.isPlaybackPaused) {
						this.startPlayback();
					} else {
						this.pausePlayback();
					}

				}}>
					{
						this.state.isPlaybackPaused ?
							(<PlayArrowIcon sx={{
								fill: "url(#gradientId)"
							}} />) :
							(<PauseIcon sx={{
								fill: "url(#gradientId)"
							}} />)
					}

				</Button>
				<GradientSlider
					min={0} max={this.state.playbackDuration} step={1}
					value={this.state.playbackTime}
					onChange={(e, v) => {
						this.seekPlayback(v);
					}}
					sx={{
						// width: "100px",
						width: "60px",
						margin: "0 10px",
					}}
				/>


				<Stack spacing={-0.1} sx={{
					justifyContent: "center",
					alignItems: "center",
				}}>
					<Typography sx={{ fontSize: "12px" }}> {getFormattedTimeText(this.state.playbackTime)} </Typography>
					<Box sx={{
						width: "100%",
						height: "1px",
						bgcolor: "black",
					}} />
					<Typography sx={{ fontSize: "12px" }}> {getFormattedTimeText(this.state.playbackDuration)} </Typography>
				</Stack>
			</Stack>

			<StyledButton sx={{ width: "40px", height: "35px" }} onClick={() => {
				// this.setState({ resetCanvasConfirmDialogOpened: true });
			}}>
				<Stack spacing={-0.6} direction="column"
					sx={{
						position: "absolute",
					}}
					onClick={(event) => {
						this.setState({
							menuOpened: true,
							menuAnchor: event.currentTarget,
							menuItems: menuItems
						});
					}}
				>
					<VolumeUpIcon sx={{
						// position: "absolute",
						height: "20px",
						fill: "black"
					}} />
					<Typography sx={{ fontSize: "12px" }}> {Math.round(this.state.displayedPlaybackVolume * 100)} </Typography>
				</Stack>
			</StyledButton>

			<Button sx={{ width: "40px", height: "35px" }} onClick={() => {
				this.downloadRecording();
			}}>
				<DownloadIcon sx={{
					position: "absolute",
					height: "30px",
					fill: "black"
				}} />
			</Button>
		</Stack>

		/////////////////////////////////////////////////////////////

		let toolbar;
		if (this.state.isRecording) {
			toolbar = recordingToolbar;
		} else {
			if (this.state.isNarrowScreen) {
				toolbar = playbackToolbarMobile;
			} else {
				toolbar = playbackToolbar;
			}
		}

		return (
			<Box sx={{
				width: "100%",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			}}>
				<audio
					ref={this.playbackAudioElementRef}
					src={this.state.recordingUrl}
					onEnded={() => {
						console.log("Playback ended")
						this.pausePlayback();
						this.setState({ playbackTime: 0 });
					}}
					type="audio/ogg"
				/>
				{toolbar}

				<Menu
					disableAutoFocusItem={true}
					anchorEl={this.state.menuAnchor}
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'center',
					}}
					transformOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
					open={this.state.menuOpened}
					onClose={(event) => closeMenu()}
				>
					{this.state.menuItems}
				</Menu>

				{/*<Alert severity="error" variant="filled" sx={{position:"fixed", top: 0, left:0}}>This is an error alert — check it out!</Alert>*/}
			</Box>
		);

	}
};